module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76mYf"))).then(() => parcelRequire('cvs7o'));